
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleFranchiseList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/franchise/list${queryString}`
    );
}

export async function consoleFranchiseGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/franchise/${item_id}/show`
    );
}

export async function consoleFranchiseCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/franchise/create`,
        payload
    );
}

export async function consoleFranchisePatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/franchise/${item_id}/patch`,
        { payload }
    );
}

export async function consoleFranchiseDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/franchise/${item_id}/delete`,
    );
}
